import React, { useState } from 'react';
import { Outlet, useParams, useSearchParams } from 'react-router-dom';

import { Box } from '@mui/material';

import './Main.css';

import { PolicyAPI } from '../features/Policy/api';
import { ToastBar } from '../components/toastBar/index';
import LocalStorageService from '../services/localStorage';

import Breadcrumbs from './components/Breadcrumbs';
import Footer from './components/Footer';
import Header from './components/Header';

const localStorageService = LocalStorageService.getService();

const Main = (props) => {
  const { orgId } = useParams();
  const [searchParams] = useSearchParams();

  const lob = searchParams.get('lob');

  const [loading, setLoading] = useState(true);
  const [brandingInfo, setBrandingInfo] = useState(null);

  React.useEffect(() => {
    let active = true;

    const loadBranding = async () => {
      setLoading(true);

      if (!orgId) {
        if (active) {
          setBrandingInfo(null);
          localStorageService.setBrandingInfo('');
          setLoading(false);
        }
        return;
      }

      let branding = null;
      try {
        const result = await PolicyAPI.getBrandingData(orgId, lob);
        branding = result?.data?.branding ?? null;
      } catch (e) {
        // Fail-safe: a tenant with no branding config renders no footer.
        console.error('Error fetching branding data', e);
      }

      if (!active) {
        return;
      }

      setBrandingInfo(branding);
      localStorageService.setBrandingInfo(branding ? JSON.stringify(branding) : '');
      setLoading(false);
    };

    loadBranding();

    return () => {
      active = false;
    };
  }, [orgId, lob]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Box component="section" className="mainLayoutBox">
      <ToastBar />
      <Header isQuestionnaire={props?.isQuestionnaire} />
      <Breadcrumbs />
      <main>
        <Outlet />
      </main>
      {brandingInfo?.footer && <Footer />}
    </Box>
  );
};

Main.propTypes = {
  isQuestionnaire: false,
};

export default Main;
